
import { Component, Vue, Watch } from 'vue-property-decorator';
import vSelect from 'vue-select';
import debounce from 'lodash/debounce';

import { Client,
         IClientSearchResultModel,
         ClientSearchResultModel, 
         NetworkModel,
         ServiceTypeModel, 
         ImportJobFileValidationItemResultModel,
         ImportJobFileProcessItemResultModel } from '@/services/api.service';
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

@Component({
  components: {
    vSelect,
  },
})
export default class ImportJobs extends Vue {

  public file: string = '';
  public availableNetworks: NetworkModel[] = [];
  public networkGid: string = '';
  public availableServiceTypes: ServiceTypeModel[] = [];
  public serviceTypeGid: string = '';
  public clientGid: string = '';

  public isSelectingFile: boolean = false;
  public isUploading: boolean = false;
  public isValidating: boolean = false;
  public hasValidationIssues: boolean = false;
  public isProcessing: boolean = false;
  public isComplete: boolean = false;

  public currentMessage: string = '';
  public processedCount: number = 0;
  public processedOKCount: number = 0;
  public processedWarningCount: number = 0;
  public processedErrorCount: number = 0;

  public clientName: string = '';
  public selectedClient: ClientSearchResultModel | null = null;
  public matchingClients: ClientSearchResultModel[] = [];

  private validationInterval: number = 0;
  private processInterval: number = 0;
  private processGid: string = '';
  
  private validationResults: ImportJobFileValidationItemResultModel[] = [];
  private processResults: ImportJobFileProcessItemResultModel[] = [];
  private mounted() {
    // get the networks
    // @ts-ignore
    this.$Progress.start();
    this.fetchInitialData();
    this.isSelectingFile = true;
  }

  @Watch('selectedClient')
  private onSelectedClientChanged(value: ClientSearchResultModel | null, oldValue: ClientSearchResultModel | null) {
    if (value !== null) {
      this.clientGid = value.gid!;
    }
    
  }
  private async fetchInitialData() {
    const clientService = new Client(process.env.VUE_APP_API_URL, this.$http);

    const [networks, serviceTypes] = await Promise.all([
      clientService.getNetworks(),
      clientService.getServiceTypes(),
    ]);

    const pickNetworkModel: NetworkModel = new NetworkModel();
    pickNetworkModel.init({ name: '(Select Network...)', gid: '' });
    this.availableNetworks = networks;
    this.availableNetworks.unshift(pickNetworkModel);

    const pickServiceTypeModel: ServiceTypeModel = new ServiceTypeModel();
    pickServiceTypeModel.init({ name: '(Select Service Type...)', gid: '' });
    this.availableServiceTypes = serviceTypes;
    this.availableServiceTypes.unshift(pickServiceTypeModel);

    // @ts-ignore
    this.$Progress.finish();
  }

  // private addFile(){
  //   // @ts-ignore
  //   this.$refs.files.click();
  // }

  private handleFileUpload() {
    // @ts-ignore
    this.file = this.$refs.file.files[0];
  }

  private sendFileToServer() {
    const vm = this;
    vm.isSelectingFile = false;
    vm.isUploading = true;
    vm.currentMessage = 'Uploading file...';
    const baseUrl = process.env.VUE_APP_API_URL;
    const url = baseUrl + '/api/v1/data/import/jobfile/upload?clientgid=' + this.clientGid + '&networkgid=' + this.networkGid + '&servicetypegid=' + this.serviceTypeGid;

    const formData = new FormData();
    formData.append('file', this.file);
    formData.append('networkGid', this.networkGid);
    formData.append('clientGid', this.clientGid);
    axios.post(url,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    ).then((response) => {
        console.log('SUCCESS!!');
        console.log(response);
        vm.processGid = response.data;
        vm.isUploading = false;
        vm.isValidating = true;
        if (vm.processGid !== '') {
          vm.startValidationStatusChecker();
        }
    })
    .catch((error) => {
      console.log('FAILURE!!');
    });
  }

  private startValidationStatusChecker() {
    this.processedOKCount = 0;
    this.processedWarningCount = 0;
    this.processedErrorCount = 0;

    let interval = 2; // 5 seconds
    interval = interval * 1000;
    this.validationInterval = window.setInterval(this.getValidationStatus, interval);
  }

  private stopValidationStatusChecker() {
    window.clearInterval(this.validationInterval);
  }

  private getValidationStatus() {
    const vm = this;
    const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
    clientService.getJobFileStatus(this.processGid).then((status) => {
      // update the props
      vm.currentMessage = status.message!;
      vm.processedOKCount = status.validationSummary!.okCount!;
      vm.processedWarningCount = status.validationSummary!.warningCount!;
      vm.processedErrorCount = status.validationSummary!.errorCount!;
      if (status.validationCompleted!) {
        console.log('VALIDATION COMPLETED!!!!!');
        vm.stopValidationStatusChecker();
        // change the state of the page, and either show errors
        // or start the import process
        if (status.validationSummary !== undefined) {
          if (status.validationSummary.errorCount! > 0 || status.validationSummary.warningCount! > 0) {
            // Need to display the validation results
            console.log('Getting validation results');
            clientService.getJobFileValidationResult(this.processGid).then ((validationresult) => {
              vm.validationResults = validationresult.items!;
              vm.hasValidationIssues = false;
            });
          } else {
            console.log('Starting processing');
            // Start the processing
            vm.isValidating = false;
            vm.isProcessing = true;
            clientService.processJobFile(this.processGid).then((data) => {
              console.log('Starting processing checker');
              vm.startProcessStatusChecker();
            });
          }
        }
      }
    });
  }


  private startProcessStatusChecker() {
    this.processedOKCount = 0;
    this.processedWarningCount = 0;
    this.processedErrorCount = 0;

    let interval = 2; // 5 seconds
    interval = interval * 1000;
    this.processInterval = window.setInterval(this.getProcessStatus, interval);
  }

  private stopProcessStatusChecker() {
    window.clearInterval(this.processInterval);
  }

  private getProcessStatus() {
    const vm = this;
    const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
    clientService.getJobFileStatus(this.processGid).then((status) => {
      // update the props
      vm.currentMessage = status.message!;
      vm.processedOKCount = status.importSummary!.okCount!;
      vm.processedWarningCount = status.importSummary!.warningCount!;
      vm.processedErrorCount = status.importSummary!.errorCount!;
      if (status.importCompleted) {
        vm.stopProcessStatusChecker();
        // change the state of the page, and either show errors
        // or start the import process
        // Need to display the process results
        clientService.getJobFileProcessResult(this.processGid).then ((processdata) => {
          vm.processResults = processdata.items!;
          vm.isProcessing = false;
          vm.isComplete = true;
        });
      }
    });
  }

  private searchForClients(search: string, loading: (show: boolean) => any) {
    if (search !== undefined && search !== null && search !== '') {
      loading(true);
      this.internalSearchForClients(search, loading, this);
    }
  }

  // Taken from: https://stackoverflow.com/questions/40686767/using-lodash-debounce-in-angular2-typescript-scroll-not-working
  private internalSearchForClients = debounce((search, loading, vm) => {
    const clientService = new Client(process.env.VUE_APP_API_URL, this.$http);
    clientService.searchClients(search).then((data) => {
      // push the results into the list
      vm.matchingClients = data;
      loading(false);
    });
  }, 300);

}
